module.exports = __webpack_public_path__ + "static/media/phone-icon--white.b1802ef2.svg";